module.exports = "favicons/favicon.ico";